// "Download the PDF report" for a finished scan. Laying the report out takes a few seconds, so the
// button says it is working (and is announced), and the result or the failure is written next to it.
import { DownloadIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiError, downloadReport } from './api';
import { Button } from './ui';

const KNOWN_ERRORS = ['informe', 'limite', 'sin-terminar'];

export function ReportButton({ scanId }: { scanId: string }) {
  const { t } = useTranslation();
  const [working, setWorking] = useState(false);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  async function download() {
    setWorking(true);
    setError('');
    setStatus(t('report.started'));
    try {
      await downloadReport(scanId);
      setStatus(t('report.ready'));
    } catch (failure) {
      const code = failure instanceof ApiError ? failure.code : null;
      setStatus('');
      setError(code && KNOWN_ERRORS.includes(code) ? t(`report.errors.${code}`) : t('report.errors.informe'));
    } finally {
      setWorking(false);
    }
  }

  const note = t('report.note');
  return (
    <div className="flex flex-col items-start gap-2">
      <Button variant="secondary" onPress={download} isPending={working}>
        <DownloadIcon aria-hidden="true" />
        {working ? t('report.working') : t('report.download')}
      </Button>
      {note && <p className="text-sm text-ink-muted">{note}</p>}
      <p role="status" className="text-sm text-ink-muted empty:hidden">
        {status}
      </p>
      {error && (
        <p role="alert" className="text-sm font-bold text-error">
          {error}
        </p>
      )}
    </div>
  );
}
